import API from '@/service/api'

export default {
  namespaced: true,
  state: {
    zohoContracts: []
  },
  getters: {
    zohoContracts: state => state.zohoContracts,
    getContractsByOffer: state => offerId => state.zohoContracts.filter(contract => contract.offer === offerId || contract.offer?.id === offerId),
    getContractsByStorage: state => storageId => state.zohoContracts.filter(contract => contract.storage === storageId || contract.storage?.id === storageId),
    getContractsByCustomer: state => customerId => state.zohoContracts.filter(contract => contract.customer === customerId || contract.customer?.id === customerId),
    getActiveContracts: state => state.zohoContracts.filter(contract => !['signed', 'declined', 'expired'].includes(contract.zohoSignStatus)),
    getContractByDocumentId: state => documentId => state.zohoContracts.find(contract => contract.zohoDocumentId === documentId)
  },
  mutations: {
    SET_ZOHO_CONTRACTS(state, contracts) {
      state.zohoContracts = contracts
    },
    ADD_ZOHO_CONTRACT(state, contract) {
      state.zohoContracts.push(contract)
    },
    UPDATE_ZOHO_CONTRACT(state, updatedContract) {
      const index = state.zohoContracts.findIndex(contract => contract.id === updatedContract.id)
      if (index !== -1) {
        state.zohoContracts.splice(index, 1, updatedContract)
      }
    },
    DELETE_ZOHO_CONTRACT(state, contractId) {
      const index = state.zohoContracts.findIndex(contract => contract.id === contractId)
      if (index !== -1) {
        state.zohoContracts.splice(index, 1)
      }
    }
  },
  actions: {
    fetchZohoContracts({ commit }) {
      return API()
        .get('/zoho-contracts')
        .then(response => {
          commit('SET_ZOHO_CONTRACTS', response.data)
          return response.data
        })
        .catch(error => {
          console.error('Error fetching Zoho contracts:', error)
          throw error
        })
    },
    createZohoContract({ commit }, contractData) {
      return API()
        .post('/zoho-contracts', contractData)
        .then(response => {
          commit('ADD_ZOHO_CONTRACT', response.data)
          return response.data
        })
        .catch(error => {
          console.error('Error creating Zoho contract:', error)
          throw error
        })
    },
    updateZohoContract({ commit }, { id, ...updateData }) {
      return API()
        .put(`/zoho-contracts/${id}`, updateData)
        .then(response => {
          commit('UPDATE_ZOHO_CONTRACT', response.data)
          return response.data
        })
        .catch(error => {
          console.error('Error updating Zoho contract:', error)
          throw error
        })
    },
    deleteZohoContract({ commit }, contractId) {
      return API()
        .delete(`/zoho-contracts/${contractId}`)
        .then(response => {
          commit('DELETE_ZOHO_CONTRACT', contractId)
          return response.data
        })
        .catch(error => {
          console.error('Error deleting Zoho contract:', error)
          throw error
        })
    }
  }
}
